import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/api/errors';

/**
 * Defaults for server state. No window-focus refetch (analytics reads cost BigQuery
 * scans; lists refetch on navigation anyway). 4xx errors are never retried: they
 * won't change on retry and a 401 has already ended the session.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
